// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProp } from "@insite/mobius/utilities";
import { hideLoadingOverlay } from "@pacific/App/Components/Common/XngLoadingOverlayUtilities";
import { mobileTippyStyle } from "@pacific/App/Components/Tippy/Style";
import { xBaseTheme } from "@pacific/XDL/types";
import { css } from "styled-components";

export default {
    css: css`
        ${hideLoadingOverlay}
        [data-tippy-root] {
            z-index: ${getProp("theme.zIndex.tippy")} !important;
        }
        ${mobileTippyStyle}

        // This style to fix an issue with Google Places autocomplete
        .pac-container {
            z-index: 10000 !important;
        }
    `,
} as xBaseTheme["globalStyle"];
